enum LabelTarget {
  DONATION = 'donation',
  CONSTITUENT = 'constituent',
}

export default LabelTarget;
